import { render, staticRenderFns } from "./ClientDetailsModal.vue?vue&type=template&id=8c72d0b0&"
import script from "./ClientDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ClientDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports